@if (commentsData && commentsData.length > 0) {
  <section class="product-comments" id="comments-list">
    <h3 class="product-comments__title">{{ 'global.comments' | translate }}</h3>
    <div class="product-comments__content">
      @for (data of commentsData; track data._id) {
        <div class="my-10">
          <pwj-comment-box [comment]="data"></pwj-comment-box>
          <!-- replies -->
          @if (data?.replies) {
            <!-- replay comment element -->
            @for (replay of data.replies; track replay) {
              <div class="my-10">
                <pwj-comment-box
                  class="block rtl:mr-16 ltr:ml-16"
                  [comment]="replay"
                  [isReplay]="true"></pwj-comment-box>
                <!-- replay of replay comment -->
                @if (replay?.replies) {
                  <!-- replay comment element -->
                  @for (comment of replay?.replies; track comment) {
                    <div class="mt-10">
                      <pwj-comment-box
                        class="block rtl:mr-32 ltr:ml-32"
                        [comment]="comment"
                        [isReplay]="true"></pwj-comment-box>
                    </div>
                  }
                }
              </div>
            }
          }
        </div>
      }
    </div>
  </section>
}
